import { Client } from "./_clientService";

const executeRequest = async (options: any) => {
  try {
    const resp = await new Client(options)[options.method]();
    return resp;
  } catch (error) {
    throw error;
  }
};

async function create(params: any) {
  return executeRequest({
    path: "/operator/create",
    payload: params,
    method: "post",
  });
}

async function update(params: any, operatorId: any) {
  return executeRequest({
    path: `/operator/update/${operatorId}`,
    payload: params,
    method: "patch",
  });
}

async function getOperators(params: any) {
  let payload: any = {
    pageNo: params?.pageNo || 1,
    pageSize: params?.pageSize || 10,
    sortDirection: params?.sortDirection || -1,
    sortBy: params?.sortBy || "createdAt",
    search: params?.search ?? "",
  };

  if (params?.skipPagination) payload["skipPagination"] = true;
  if (params?.platform) payload["platform"] = params.platform;

  if (params?.liveStatus) payload["liveStatus"] = params.liveStatus;
  if (params?.activeStatus) payload["activeStatus"] = params.activeStatus;

  const urlParams = new URLSearchParams(payload).toString();

  return executeRequest({
    path: `/operator/list?${urlParams}`,
    method: "get",
  });
}

async function getOperatorInfo(operatorId: any) {
  if (!operatorId) throw new Error("No operator id provided");

  return executeRequest({
    path: `/operator/info/${operatorId}`,
    method: "get",
  });
}

async function revealOperatorPassword(operatorId: any) {
  if (!operatorId) throw new Error("No operator id provided");

  return executeRequest({
    path: `/operator/password/${operatorId}`,
    method: "get",
  });
}

export async function updateOperatorStatus(platformId: any) {
  const response = await new Client({
    path: `/operator/update/status/${platformId}`,
  }).patch();

  return response;
}

export async function updateOperatorLiveStatus(operatorId: any) {
  const response = await new Client({
    path: `/operator/update/live-status/${operatorId}`,
  }).patch();

  return response;
}

export async function deleteOperator(platformId: any) {
  const response = await new Client({
    path: `/operator/delete/${platformId}`,
  }).delete();

  return response;
}

export async function permanentDeleteOperator(platformId: any) {
  const response = await new Client({
    path: `/operator/delete/permanent/${platformId}`,
  }).delete();

  return response;
}

async function updateOperatorVaultConfig(params: any) {
  return executeRequest({
    path: "/operator/updateVaultConfig",
    payload: params,
    method: "post",
  });
}

async function toggleGlobalMaintenance(enabled: boolean) {
  return executeRequest({
    path: "/operator/global-maintenance",
    payload: { enabled },
    method: "post",
  });
}

async function getPortalRegistry() {
  return executeRequest({
    path: "/portal/registry",
    method: "get",
  });
}

export async function updateOperatorFilterPreference(params: {
  liveStatus?: string | null;
  activeStatus?: string | null;
}) {
  return executeRequest({
    path: "/user/operator-filter-preference",
    payload: params,
    method: "patch",
  });
}

export async function resetOperatorFilterPreference() {
  return executeRequest({
    path: "/user/operator-filter-preference/reset",
    method: "post",
  });
}

async function quickCreateOperator(params: {
  platform: string;
  operatorName: string;
  externalOpId: string;
  game: string;
}) {
  return executeRequest({
    path: "/operator/quick-create",
    payload: params,
    method: "post",
  });
}

export {
  create,
  update,
  getOperators,
  getOperatorInfo,
  revealOperatorPassword,
  updateOperatorVaultConfig,
  toggleGlobalMaintenance,
  getPortalRegistry,
  quickCreateOperator,
};
